import { formikNotEmptyValidator } from "@apoly-42/apoly-utils";
import * as React from 'react';
import { formMessages } from '../../app-utilities/appMessages';
import { I18nMessage } from '../I18nMessage';

export const noEmptyFormField = formikNotEmptyValidator(
  <I18nMessage message={formMessages.noEmptyField} />
);
